import { ReactNode } from 'react';
import { Box, FormControlLabel, FormControlLabelProps } from '@mui/material';
import { FormControlLabelSx } from './RadioLabelProps';

type Props = FormControlLabelProps & {
  error?: boolean;
  errors?: string[];
  tooltip?: ReactNode;
};

const RadioLabel = (props: Props) => {
  const { sx, error, errors, tooltip, className, ...rest } = props;
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      <FormControlLabel
        {...rest}
        sx={{ ...FormControlLabelSx, ...sx }}
        className={`${className ?? ''} ${error ? 'error' : ''}`}
      />
      {error && tooltip}
    </Box>
  );
};

export default RadioLabel;
